import axiosNest from '../../../api/axiosNest';

/**
 * Panel „Do zrobienia” i czynności po obsadzeniu na karcie zlecenia (prace
 * 24.10.2026, G1/K1; przełącznik `orderChecklist`, S-24.10-01; API:
 * `apps/api/src/order-checklist/`). Pozycje liczy API z danych, które już
 * są w bazie — front tylko je pokazuje.
 */

/** Klucz przełącznika — jak w API. */
export const FEATURE_ORDER_CHECKLIST = 'orderChecklist';

export type TodoTone = 'error' | 'warning' | 'info' | 'ok';
export type TodoTarget = 'suggestions' | 'variants' | 'alerts' | 'notes';

export interface OrderTodoItem {
  key: string;
  tone: TodoTone;
  title: string;
  detail: string;
  link?: { target: TodoTarget; label: string };
}

/** Klucze czynności — dane API. */
export type ChecklistKey = 'timeslot' | 'allocation' | 'advice' | 'instructions';

export interface ChecklistItem {
  key: ChecklistKey;
  label: string;
  hint: string;
  done: boolean;
  changedBy: string | null;
  changedAt: string | null;
}

export interface Checklist {
  carId: number;
  canCheck: boolean;
  items: ChecklistItem[];
  allocation: { vehicle: string | null; driver: string | null; trimbleTerminal: string | null };
}

export interface OrderTodo {
  items: OrderTodoItem[];
  checklist: Checklist | null;
}

export async function fetchOrderTodo(id: number | string): Promise<OrderTodo> {
  const { data } = await axiosNest.get<OrderTodo>(`/user-offers/${id}/todo`);
  return data;
}

export async function setChecklistItem(id: number | string, key: ChecklistKey, done: boolean): Promise<OrderTodo> {
  const { data } = await axiosNest.put<OrderTodo>(`/user-offers/${id}/checklist/${key}`, { done });
  return data;
}

/** Komunikat błędu z odpowiedzi API (polski z serwera) albo ogólny. */
export function todoErrorMessage(e: unknown): string {
  const message = (e as { response?: { data?: { message?: unknown } } })?.response?.data?.message;
  if (typeof message === 'string' && message.trim() !== '') return message;
  return 'Nie udało się zapisać czynności — spróbuj ponownie.';
}
